import { render, staticRenderFns } from "./Setting.List.vue?vue&type=template&id=c4f06e8e&"
import script from "./Setting.List.vue?vue&type=script&lang=js&"
export * from "./Setting.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports